import { Navigate, PathRouteProps, Route } from "react-router";

import JobTrackerLayout from "./JobTrackerLayout";
import { SalesOrderDetails } from "./components/SalesOrderDetails";
import { BomByComponent } from "./components/bom-by-component/BomByComponent";
import { BomHierarchy } from "./components/bom-hierarchy/BomHierarchy";
import { Builds } from "./components/builds/Builds";
import { ERNs } from "./components/erns/ERNs";
import { ExistingInventory } from "./components/existing-inventory/ExistingInventory";
import { LandedCosts } from "./components/landed-costs/LandedCosts";
import { PurchaseOrders } from "./components/purchase-orders/PurchaseOrders";
import { PurchasingProgress } from "./components/purchasing-progress/PurchasingProgress";
import { Shipments } from "./components/shipments/Shipments";
import { withJobTrackingData } from "./components/withJobTrackingData";
import { WorkOrders } from "./components/work-orders/WorkOrders";

export type JobTrackerPath =
  | "details"
  | "financial-summary"
  | "erns"
  | "bom-hierarchy"
  | "bom-by-component"
  | "existing-inventory"
  | "purchase-orders"
  | "purchasing-progress"
  | "landed-costs"
  | "work-orders"
  | "work-order-creation"
  | "builds"
  | "fabrication-progress"
  | "shipments";

/** A copy of `<Route/>` from `react-router`, with the props restricted to only accept paths in the `JobTrackerPath` type */
const JobTrackerRoute: React.FC<Omit<PathRouteProps, "path"> & { path: JobTrackerPath }> = Route;

export const jobTrackerRoutes = (
  <Route path="job/:jobNumber" element={<JobTrackerLayout />}>
    <Route index element={<Navigate to={"./details"} />} />
    <JobTrackerRoute path="details" element={<SalesOrderDetails />} />
    <JobTrackerRoute path="financial-summary" element={<div>TODO: Financial Summary</div>} />
    <JobTrackerRoute path="erns" element={<ERNs />} />
    <JobTrackerRoute
      path="bom-hierarchy"
      Component={withJobTrackingData(({ salesOrderBomHierarchy, job }) => (
        <BomHierarchy bomHierarchy={salesOrderBomHierarchy} job={job} />
      ))}
    />
    <JobTrackerRoute
      path="bom-by-component"
      Component={withJobTrackingData(({ bomComponents, job }) => (
        <BomByComponent bomComponents={bomComponents} jobId={job.id} />
      ))}
    />
    <JobTrackerRoute path="existing-inventory" element={<ExistingInventory />} />
    <JobTrackerRoute path="purchase-orders" element={<PurchaseOrders />} />
    <JobTrackerRoute path="purchasing-progress" element={<PurchasingProgress />} />
    <JobTrackerRoute path="landed-costs" element={<LandedCosts />} />
    <JobTrackerRoute path="work-orders" element={<WorkOrders />} />
    <JobTrackerRoute path="work-order-creation" element={<div>TODO: Work Order Creation</div>} />
    <JobTrackerRoute path="builds" element={<Builds />} />
    <JobTrackerRoute path="fabrication-progress" element={<div>TODO: Fabrication Progress</div>} />
    <JobTrackerRoute path="shipments" element={<Shipments />} />
  </Route>
);

export const pageTitleForJobTrackerPath: Record<JobTrackerPath, string> = {
  details: "Sales Order Details",
  "financial-summary": "Financial Summary",
  erns: "ERNs",
  "bom-hierarchy": "BOM Hierarchy",
  "bom-by-component": "BOM By Component",
  "existing-inventory": "Existing Inventory",
  "purchase-orders": "Purchase Orders",
  "purchasing-progress": "Purchasing Progress",
  "landed-costs": "Landed Costs",
  "work-orders": "Work Orders",
  "work-order-creation": "Work Order Creation",
  builds: "Builds",
  "fabrication-progress": "Fabrication Progress",
  shipments: "Shipments",
};
